import {computeIsConfigTable} from 'notebook/tables/store/logic/TableContextLogic';
import {createTableModelSelector} from 'notebook/tables/store/selectors/util/SelectorCreators';
import {TableEditableStore, TableEditableVolatileProps} from 'notebook/tables/store/TableStore';

export interface TableContextModel {
  isConfigTable: boolean;

  /*
  TODO(BNCH-146929): Future properties to be added as logic is transitioned out of TableEditable:
  tableProvenanceUuid: string | null; // From _getTableProvenanceUuid()
  */
}

export function createTableContextSelector(
  volatilePropsSelector: (store: TableEditableStore) => TableEditableVolatileProps
): (store: TableEditableStore) => TableContextModel {
  return createTableModelSelector(
    [
      (store) => volatilePropsSelector(store).table,
      (store) => store.editorContext.isConfig,
      (store) => store.stableProps.fileIsConfig,
    ],
    (table, editorContextIsConfig, fileIsConfigProp) => ({
      isConfigTable: computeIsConfigTable(table, editorContextIsConfig, fileIsConfigProp),
    })
  );
}
